import React from 'react'
import { t } from '../../components/i18n/i18n'
import BibleViewer from '../../components/bible/BibleViewer'
import back from '../../assets/images/elements/holyBible.jpeg'
import '../../assets/css/pages.css'

export const Bible = () => (
  <>
    <div className='page-hero'>
      <img src={back} alt='' />
      <div className='page-hero__overlay' />
      <h1 className='page-hero__title'>{t('bibleOnline')}</h1>
    </div>

    <div className='bible-page'>
      <BibleViewer />
    </div>
  </>
)
